# GraphQL query to get all the stage goals for a given stage

#import "../fragments/sales-automation-stage-goal.graphql"

query StageGoalsForStage($stageId: ID!) {
    editableGoals(stageId: $stageId) {
        ...SalesAutomationStageGoal
    }
}
